<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>And to All a Good Night</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Felicitas Ivey</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Kobbi Aackers was excited to have a traditional family Christmas with his younger sister Franzi, a famous rock star. But instead of the peaceful holiday he had planned, she’s turning it into a televised musical extravaganza in a desperate bid for publicity.</p>
<p class="P_Normal">Kobbi can adapt, especially since the show’s host Wytt Kanard is easy on the eyes and easy to work with, even if he doesn’t believe in Christmas at all. Wytt is alternatively amused and horrified at the simplicity that is Kobbi’s life and the enthusiasm he has for the holiday, all while taking care of his houseful of unexpected guests.</p>
<p class="P_Normal">Maybe Kobbi can convince the cynical Wytt that Christmas isn’t an event to be managed, but something special to be shared. Maybe he can muster the courage to confess his attraction and offer Wytt a surprise present.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?4b2cf78d